<template>
    <div class="full-part white-background" ref="loginView">
<!--        <el-scrollbar>-->
            <div class="shopopee-title">
                <span class="part-1">3DShop</span>
                <span class="part-2">opee</span>
            </div>

            <accLogin
                ref="loginDom"
                v-show="viewPart === 'login'"
                :autoLogin="autoLogin"
                @login-check-complete="loginCallback"
                @clickGoSignup="goSignupCallback"
                @clickGoSendVCode="goSendVCodeCallback"
                @clickReActivate="goReActivate"
            />

            <accSignUp
                v-if="viewPart === 'signup'"
                @clickReturnBtn="clickReturnFunc"
                @signup-complete="signupCallback"
                ref="signupDom"
            />
<!--        </el-scrollbar>-->
    </div>
</template>

<script setup>
    import accLogin from "@/components/shopopee/login/accLogin.vue";
    import accSignUp from "@/components/shopopee/login/accSignUp.vue";
    import {ref, onBeforeMount, nextTick} from "vue"

    const props = defineProps(["autoLogin", "viewPart"])
    const emits = defineEmits(["login-check-complete"])

    const viewPart = ref("login")

    const loginDom = ref(null)
    const signupDom = ref(null)

    function loginCallback(value){
        emits("login-check-complete", value)
    }

    function goSignupCallback(){
        viewPart.value = "signup"
    }

    function clickReturnFunc(){
        viewPart.value = "login"
    }

    function signupCallback(obj){
        loginDom.value.loginFunc(obj.login, obj.password)
        viewPart.value = "login"
    }

    function goSendVCodeCallback(login, icode){

    }

    function goReActivate(login){
        viewPart.value = "signup"

        nextTick(() => {
            signupDom.value.goActivate(login)
        })
    }

    onBeforeMount(() => {
        if (props.viewPart === "signup"){
            viewPart.value = "signup"
        }
    })

</script>

<style scoped>
    .shopopee-title {
        font-size: 44px;
        text-align: center;
        font-weight: 700;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .shopopee-title .part-1 {
        color: #8400FF;
    }

    .shopopee-title .part-2 {
        color: #02A7F0;
    }

    .full-part {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        margin: auto;
        padding-left: 5%;
        padding-right: 5%;
    }

    .white-background {
        background: #fff;
    }
</style>